// Engine-tier (WhatsApp store + vault) page decision for Team Inbox "load older".
//
// The Baileys engine answers `backfilling:true` when the store was exhausted and
// it started fetching older history from the phone that didn't land within its
// wait — those rows reach its store a few seconds later. So while backfilling
// (and retries remain) the engine tier is NOT exhausted: the caller re-requests
// the same page after BACKFILL_RETRY_DELAY_MS. The extension engine never sets
// `backfilling` for browse, so for it this is exactly the previous rule.

export const BACKFILL_RETRY_DELAY_MS = 5000;
export const MAX_BACKFILL_RETRIES = 2;

export interface EnginePageInput {
    /** WhatsApp source gate. Off ⇒ the engine returned vault-only (not offset-paged). */
    waGate: boolean;
    messagesCount: number;
    hasMoreInStore?: boolean;
    backfilling?: boolean;
    /** 0 = original request, n = n-th backfill retry of the same page. */
    attempt: number;
    limit: number;
}

export function decideEnginePage(input: EnginePageInput): { engineHasMore: boolean; backfillPending: boolean } {
    const { waGate, messagesCount, hasMoreInStore, backfilling, attempt, limit } = input;
    const backfillPending = waGate && !!backfilling && attempt < MAX_BACKFILL_RETRIES;
    const storeHasMore = waGate && messagesCount > 0 && (hasMoreInStore ?? messagesCount >= limit);
    return { engineHasMore: backfillPending || storeHasMore, backfillPending };
}
